/* eslint-disable max-len */

import React, { Suspense, useEffect, useState } from "react";
import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";

// HOOKS
import { I18nextProvider } from "react-i18next";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";

// PAGES
import SelfService from "./SelfService/SelfService";
import BasketMix from "./BehaviourAnalysis/BasketMix/BasketMix";
import TaticalAnalysis from "./TaticalAnalysis/TaticalAnalysis";
import StrategicAnalysis from "./StrategicAnalysis/StrategicAnalysis";

// COMPONENTS
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";

// ASSETS
// import logo from '../assets/logo.png';
import logo from "../assets/icons/logoPadSales.svg";
import "../style.scss";
import i18n from "../i18n";

function LayoutPage() {
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [isLoading, setIsLoading] = useState(false);
  // App OnDemand

  return isLoading ? (
    <AppLoader />
  ) : (
    <div style={{ left: leftBarOpened && "224px" }} className={"appWrapper"}>
      <div id="expandedWrapper" />
      <HashRouter>
        <LeftSideMenu config={config} logo={logo} />

        {/* <Header /> */}

        <Switch>
          <Route
            path="/strategic-analysis"
            exact
            render={() => <StrategicAnalysis config={config} />}
          />
          <Route exact path="/">
            <Redirect to="/strategic-analysis" />
          </Route>
          <Route
            path="/tatical-analysis"
            exact
            render={() => <TaticalAnalysis config={config} />}
          />
          <Route
            path="/behaviour-analysis/basket-mix"
            exact
            render={() => <BasketMix config={config} />}
          />
          <Route
            path="/self-service"
            exact
            render={() => <SelfService config={config} />}
          />
        </Switch>
      </HashRouter>
    </div>
  );
}

export default function Layout() {
  return (
    <Suspense fallback={<AppLoader />}>
      <I18nextProvider i18n={i18n}>
        <LayoutPage />
      </I18nextProvider>
    </Suspense>
  );
}
